import { useParams } from "react-router-dom";
import { useSprintQuery } from "sprint-common-web";

import { useAssetsApi } from "../../../../../common/api/master-api/assets/useAssetsApi";
import { mapToOnPremAssetDetails, OnPremAssetDetails } from "../../OnPremAssetDetails";
import { OnPremAssetQueryKey } from "../OnPremAssetQueryKey";

export const useOnPremAssetDetails = () => {
    const { assetId } = useParams<{ assetId: string }>();
    const { getOnPremAssetDetails } = useAssetsApi();

    return useSprintQuery<OnPremAssetDetails>({
        queryKey: [OnPremAssetQueryKey.OnPremAssetDetails, assetId],
        queryFn: async (): Promise<OnPremAssetDetails> => {
            const response = await getOnPremAssetDetails({ assetId });

            return mapToOnPremAssetDetails(response);
        }
    });
};
